
const state = {
  show: false,
  emailInfo: {}
}

const actions = {
  updateEmail (ctx, item) {
    ctx.commit('updateEmail', item)
  }
}

const mutations = {
  updateEmail (state, item) {
    state.emailInfo = item
  },
  showAddEmail (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
